/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from "clsx";
import { FC } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./HeaderNotificationsMenuCSS.css";
import { defaultAlerts, KTIcon, toAbsoluteUrl } from "../../../helpers";

const HeaderNotificationsMenu = ({ requestSMSCount }) => {
  const { t } = useTranslation();

  return (
    <div
      className="menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px"
      data-kt-menu="true"
    >
      <div
        className="d-flex flex-column bgi-no-repeat rounded-top"
        style={{
          backgroundImage: `url('${toAbsoluteUrl("/media/misc/header notifications.png")}')`,
        }}
      >
        <h3 className="text-white fw-semibold px-9 mt-10 mb-6">
          {t("NOTIFICATIONS.NOTIFICATIONS")}
          <span className="fs-8 opacity-75 ps-3">
            {t("NOTIFICATIONS.REPORT_COUNT", { count: requestSMSCount ? 1 : 0 })}
          </span>
        </h3>
      </div>

    <div className="tab-content">
      <div
        className="tab-pane fade show active"
        id="kt_topbar_notifications_1"
        role="tabpanel"
      >
        <div className="mh-325px my-5 px-8">
          {/* <div className="scroll-y mh-325px my-5 px-8"> */}
          {requestSMSCount ? (
            <Link
              to="deviceRequests/notSent"
              className="fs-6 text-gray-800 text-hover-primary fw-bolder"
            >
              <div className="mb-0 me-2">
                {t("NOTIFICATIONS.LOW_BALANCE")}
                <div className="text-gray-400 fs-7">
                  {t("NOTIFICATIONS.SMS_NOT_SENT_LOW_BALANCE", { count: requestSMSCount })}
                </div>
              </div>
            </Link>

          ) : (
            <div className="d-flex flex-column px-9">
              <div className="pt-10 pb-0">
                <h3 className="text-dark text-center fw-bold">
                  {t("NOTIFICATIONS.NO_NOTIFICATIONS")}
                </h3>
              </div>
            </div>
          )}

          {/* {defaultAlerts.map((alert, index) => (
            <div key={`alert${index}`} className="d-flex flex-stack py-4">
              <div className="d-flex align-items-center">
                <div className="symbol symbol-35px me-4">
                  <span
                    className={clsx("symbol-label", `bg-light-${alert.state}`)}
                  >
                    {" "}
                    <KTIcon
                      iconName={alert.icon}
                      className={`fs-2 text-${alert.state}`}
                    />
                  </span>
                </div>

                <div className="mb-0 me-2">
                  <a
                    href="#"
                    className="fs-6 text-gray-800 text-hover-primary fw-bolder"
                  >
                    {alert.title}
                  </a>
                  <div className="text-gray-400 fs-7">{alert.description}</div>
                </div>
              </div>

              <span className="badge badge-light fs-8">{alert.time}</span>
            </div>
          ))} */}
        </div>

        {/* <div className="py-3 text-center border-top">
          <Link
            to="#"
            className="btn btn-color-gray-600 btn-active-color-primary"
          >
            View all <KTIcon iconName="arrow-right" className="fs-5" />
          </Link>
        </div> */}
      </div>
    </div>
    </div>
  );
};

export { HeaderNotificationsMenu };
